import React from 'react'
import NotFound from '../components/NotFound'

class NotFoundPage extends React.Component {
  render() {
    return(
      <div>
        <NotFound path="/locations"></NotFound>
      </div>
    )
  }
}

export default NotFoundPage


// WEBPACK FOOTER //
// ./src/pages/404.js